import React from 'react';
import { motion } from 'framer-motion';
import './AdminSidebar.css';

/**
 * Admin Sidebar - Navigation component for admin dashboard
 */
const AdminSidebar = ({
  collapsed,
  onToggle,
  activeView,
  onViewChange,
  availableTables,
  onTableSelect,
  selectedTable
}) => {
  const sidebarVariants = {
    expanded: { width: '256px' },
    collapsed: { width: '64px' }
  };

  const menuItems = [
    { key: 'overview', label: 'Overview', icon: '🏠' },
    { key: 'analytics', label: 'Analytics', icon: '📊' },
    { key: 'settings', label: 'Settings', icon: '⚙️' },
  ];

  return (
    <motion.aside
      className="admin-sidebar"
      variants={sidebarVariants}
      animate={collapsed ? 'collapsed' : 'expanded'}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
      {/* Header */}
      <div className="admin-sidebar__header">
        <motion.div
          className="admin-sidebar__logo"
          initial={false}
          animate={{ opacity: collapsed ? 0 : 1 }}
          transition={{ duration: 0.2 }}
        >
          {!collapsed && (
            <>
              <span className="admin-sidebar__logo-icon">👑</span>
              <span className="admin-sidebar__logo-text">VASSTR Admin</span>
            </>
          )}
        </motion.div>

        <button
          className="admin-sidebar__toggle"
          onClick={onToggle}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <span className={`admin-sidebar__toggle-icon ${collapsed ? 'collapsed' : ''}`}>
            {collapsed ? '→' : '←'}
          </span>
        </button>
      </div>

      {/* Navigation */}
      <nav className="admin-sidebar__nav">
        <div className="admin-sidebar__section">
          <motion.h3
            className="admin-sidebar__section-title"
            initial={false}
            animate={{ opacity: collapsed ? 0 : 1 }}
            transition={{ duration: 0.2 }}
          >
            {!collapsed && 'Navigation'}
          </motion.h3>

          <ul className="admin-sidebar__menu">
            {menuItems.map((item) => (
              <li key={item.key} className="admin-sidebar__menu-item">
                <button
                  className={`admin-sidebar__menu-button ${
                    activeView === item.key ? 'active' : ''
                  }`}
                  onClick={() => onViewChange(item.key)}
                  title={collapsed ? item.label : ''}
                >
                  <span className="admin-sidebar__menu-icon">{item.icon}</span>
                  <motion.span
                    className="admin-sidebar__menu-label"
                    initial={false}
                    animate={{ opacity: collapsed ? 0 : 1 }}
                    transition={{ duration: 0.2 }}
                  >
                    {!collapsed && item.label}
                  </motion.span>
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Tables Section */}
        <div className="admin-sidebar__section">
          <motion.h3
            className="admin-sidebar__section-title"
            initial={false}
            animate={{ opacity: collapsed ? 0 : 1 }}
            transition={{ duration: 0.2 }}
          >
            {!collapsed && 'Data Tables'}
          </motion.h3>

          <ul className="admin-sidebar__menu admin-sidebar__tables-menu">
            {availableTables.map((table) => (
              <li key={table.key} className="admin-sidebar__menu-item">
                <button
                  className={`admin-sidebar__menu-button ${
                    selectedTable === table.key ? 'active' : ''
                  }`}
                  onClick={() => onTableSelect(table.key)}
                  title={collapsed ? table.label : table.description}
                >
                  <span className="admin-sidebar__menu-icon">{table.icon}</span>
                  <motion.span
                    className="admin-sidebar__menu-label"
                    initial={false}
                    animate={{ opacity: collapsed ? 0 : 1 }}
                    transition={{ duration: 0.2 }}
                  >
                    {!collapsed && table.label}
                  </motion.span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Footer */}
      <div className="admin-sidebar__footer">
        <motion.div
          className="admin-sidebar__version"
          initial={false}
          animate={{ opacity: collapsed ? 0 : 1 }}
          transition={{ duration: 0.2 }}
        >
          {!collapsed && (
            <>
              <div className="admin-sidebar__version-text">
                Admin Panel v1.0
              </div>
              <div className="admin-sidebar__version-build">
                Build: {new Date().getFullYear()}
              </div>
            </>
          )}
        </motion.div>
      </div>
    </motion.aside>
  );
};

export default AdminSidebar;